import React, { lazy, useEffect } from 'react';
import _ from 'lodash'
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

const Login = lazy(() => import('@container/profile/authentication/overview/SignIn'));


const Home = lazy(() => import('@container/home'));//主页面
const Parent = lazy(() => import('@container/parent'));//父级页面
const Page401 = lazy(() => import('@container/profile/authentication/overview/401'));

const AdminUser = lazy(() => import('@container/admin/users/index'));
const PrivateTransaction = lazy(() => import('@container/admin/privateTransaction/index'));
const StockManagement = lazy(() => import('@container/admin/stockManagement/index'));
const sellerApplication = lazy(() => import('@container/admin/sellerApplication/SellerApplicationList'));//卖家申请
const SellerApplicationDetails = lazy(() => import('@container/admin/sellerApplication/SellerApplicationDetails'));//卖家申请详情
const PendingOrders = lazy(() => import('@container/PendingOrders/PendingOrders'));
const WhiskyOffers = lazy(() => import('@container/admin/whiskyOffers/index'));
const BecomeSeller = lazy(() => import('@container/BecomeSeller/home'));
const Company = lazy(() => import('@container/BecomeSeller/Company'));
const Personal = lazy(() => import('@container/BecomeSeller/Personal'));
const EditPersonal = lazy(() => import('@container/BecomeSeller/EditPersonal'));
const EditCompany = lazy(() => import('@container/BecomeSeller/EditCompany'));

const Orders = lazy(() => import('@container/admin/orders'));
const Bids = lazy(() => import('@container/admin/bids'));
const Wallets = lazy(() => import('@container/admin/wallets'));
const Points = lazy(() => import('@container/admin/Points'));
const Coupons = lazy(() => import('@container/admin/coupons'));
const CouponHistory = lazy(() => import('@container/admin/couponHistory'));
const ListFilter = lazy(() => import('@container/admin/listFilter'));
const Cellars = lazy(() => import('@container/admin/cellars'));


//主页面路由

/**
 * @description: route object props
 * @parameter {path} String route path
 * @parameter {meta} Object route meta,has title
 * @parameter {name} String route name
 * @parameter {hiddenBreadCrumb} Boolean route need hidden on bread crumb
 * @parameter {hiddenMenu} Boolean route need hidden on menu list
 * @parameter {component} Node route render componet
 * @parameter {routes} Array routes child componet,has route object
 * @author: Mingzhen
 * @return {*}
 */
const routerContent = [
  {
    path: '/home/admin/users',
    name: 'Users',
    meta: {
      title: 'MenuList.Admin.Users'
    },
    component: AdminUser,
  },
  {
    path: '/home/admin/all-pending-orders',
    name: 'AllPendingOrders',
    meta: {
      title: "MenuList.AllPendingOrders",
      isAdmin: true
    },
    component: PendingOrders,
  },
  {
    path: '/home/admin/private-transaction',
    name: 'PrivateTransaction',
    meta: {
      title: "MenuList.Admin.PrivateTransaction",
      isAdmin: true
    },
    component: PrivateTransaction,
  },
  {
    path: '/home/admin/stock-management',
    name: 'StockManagement',
    meta: {
      title: "MenuList.Admin.StockManagement",
      isAdmin: true
    },
    component: StockManagement,
  },
  {
    path: '/home/admin/whisky-offers',
    name: 'WhiskyOffers',
    meta: {
      title: "MenuList.Admin.WhiskyOffers",
      isAdmin: true
    },
    component: WhiskyOffers,
  },
  {
    path: '/home/admin/sellerApplication',
    name: 'Seller application',
    meta: {
      title: 'MenuList.Admin.SellerApplication'
    },
    component: Parent,
    isRoot: true,
    routes: [
      {
        path: '/home/admin/sellerApplication',
        name: 'Seller application',
        meta: {
          title: 'MenuList.Admin.SellerApplication'
        },
        exact: true,
        component: sellerApplication,
      },
      {
        path: '/home/admin/sellerApplication/SellerApplicationDetails/:id',
        name: 'Seller application details',
        meta: {
          title: 'MenuList.Admin.SellerApplicationDetails'
        },
        exact: true,
        component: SellerApplicationDetails,
      },
      // {
      //   path: '/home/admin/stock-management',
      //   name: 'StockManagement',
      //   meta: {
      //     title: 'MenuList.Admin.PersonalSellerEditing'
      //   },
      //   exact: true,
      //   component: EditPersonal,
      // },
      {
        path: '/home/admin/sellerApplication/EditCompany/:id',
        name: 'Company seller editing',
        meta: {
          title: 'MenuList.Admin.CompanySellerEditing'
        },
        exact: true,
        component: EditCompany,
      },
      {
        path: '/home/admin/sellerApplication/EditPersonal/:id',
        name: 'Company seller editing',
        meta: {
          title: 'MenuList.Admin.PersonalSellerEditing'
        },
        exact: true,
        component: EditPersonal,
      },
    ]
  },
  {
    path: '/home/admin/orders',
    name: 'Orders',
    meta: {
      title: "MenuList.Admin.Orders",
      isAdmin: true
    },
    component: Orders,
  },
  {
    path: '/home/admin/Bids',
    name: 'Bids',
    meta: {
      title: "MenuList.Admin.Bids",
      isAdmin: true
    },
    component: Bids,
  },
  {
    path: '/home/admin/Wallets',
    name: 'Wallets',
    meta: {
      title: "MenuList.Admin.Wallets",
      isAdmin: true
    },
    component: Wallets,
  },
  {
    path: '/home/admin/Points',
    name: 'Points',
    meta: {
      title: "MenuList.Admin.Points",
      isAdmin: true
    },
    component: Points,
  },
  {
    path: '/home/admin/Coupons',
    name: 'Coupons',
    meta: {
      title: "MenuList.Admin.Coupons",
      isAdmin: true
    },
    component: Coupons,
  },
  {
    path: '/home/admin/CouponHistory',
    name: 'CouponHistory',
    meta: {
      title: "MenuList.Admin.CouponHistory",
      isAdmin: true
    },
    component: CouponHistory,
  },
  {
    path: '/home/admin/ListFilter',
    name: 'ListFilter',
    meta: {
      title: "MenuList.Admin.ListFilter",
      isAdmin: true
    },
    component: ListFilter,
  },
    {
    path: '/home/admin/Cellars',
    name: 'Cellars',
    meta: {
      title: "MenuList.Admin.Cellars",
      isAdmin: true
    },
    component: Cellars,
  },
]

/**
 * @description: 为routes添加面包屑数组
 * @parameter {Array}breadCrumb 面包屑数组
 * @parameter {Object}route 当前路由
 * @author: Mingzhen
 * @return {*}
 */
const routesMap = new Map();
const getBreadCrumb = route => {
  let lastPath = window.location.pathname.split('/');
  const breadCrumb = routesMap.get(route).map(item => {
    item.path = lastPath.slice(0, item.path.split('/').length).join('/');
    return item;
  });
  return breadCrumb;
}
const routeHandler = (breadCrumb, route) => {
  // 如果是单纯的菜单，那么不添加入面包屑内
  if (!route.hiddenBreadCrumb) {
    // 如果当前route和上一级同名，则合并，path保留最新
    if (breadCrumb.length && breadCrumb[breadCrumb.length - 1].breadcrumbName === route.meta?.title) {
      breadCrumb[breadCrumb.length - 1].path = route.path;
    } else {
      // 不同名加入面包屑数组内
      breadCrumb.push({
        path: route.path,
        breadcrumbName: route.meta?.title
      })
    }
  }
  // 递归处理子路由
  if (route?.routes?.length) {
    route.routes = route.routes.map(tem => routeHandler([...breadCrumb], tem));
  }
  // Add params
  route.meta = route.meta || {};
  routesMap.set(route.path, breadCrumb)
  route.meta.breadCrumb = breadCrumb;
  route.meta.getBreadCrumb = () => getBreadCrumb(route.path);
  return route
}
// 批处理routes
routerContent.map(route => {
  return routeHandler([], route)
})
//总路由
const routes = [
  {
    path: "/",
    exact: true,
    render: () => <Redirect to={"/login"} />,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/401',
    name: '401',
    component: Page401
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    routes: routerContent
  },
]

/**
 * @description: 批量处理所有主路由，目前实现：隐藏所有hidden为true的菜单，不在菜单栏中显示 
 * @parameter {Array} route 需要处理的路由数组
 * @author: Mingzhen
 * @return {*}
 * @TODO 进一步可在此作权限相关操作比如过滤掉无权限路由
 */
const routerContentHandler = (route) => {
  if (route?.routes?.length) {
    route.routes = route.routes.filter(tem => !tem.hiddenMenu).map(tem => routerContentHandler(tem));
  }
  return route;
}
// 过滤后的routerContent
const routerContentFilterData = _.cloneDeep(routerContent).filter(tem => !tem.hiddenMenu).map(tem => routerContentHandler(tem));





const RouterCreate = () => {
  const notCommonRoutes = ['/home/admin']
  const roleRoutes = {
    adminRoutes: ['/home/admin'],
    // personRoutes: ['/home/BecomeSeller', '/home/myoffers'],
    // personSellarRoutes: ['/home/BecomeSeller', '/home/myoffers', '/home/pending-orders'],
    // businessSellarRoutes: ['/home/BecomeSeller', '/home/pending-orders']
  }

  // 4:Admin
  // 1.普通用户，待申请成为卖家
  // 2.个人卖家
  // 3.公司卖家
  const roleEnum = {
    4: 'adminRoutes',
    // 1: 'personRoutes',
    // 2: 'personSellarRoutes',
    // 3: 'businessSellarRoutes'
  }
  const { user } = useSelector(store => {
    return {
      user: store.auth.loginResponse || {}
    };
  });
  let role = user.user?.role || [];
  let params = {
    routesData: [...routes],
    routeMenu: [...routerContentFilterData]
  }
  const getRouteMenuHome = (data = params.routeMenu) => {
    let notfilter = [];
    role.map(item => {
      notfilter = notfilter.concat(roleRoutes[roleEnum[item]] || []);
    })

    return data.filter(route => {
      return !(notCommonRoutes.includes(route.path) && !notfilter.includes(route.path))
    })
  }
  const getRoutes = () => {
    params.routesData[2].routes = getRouteMenuHome(routerContent);
    return params.routesData
  }
  return { ...params, getRouteMenuHome, getRoutes }
}

export {
  routes,
  routerContent,
  routerContentFilterData as routeMenu
};
export default RouterCreate;
